import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { MenuResponse } from "../../api/menus";

interface MenuState {
    items: MenuResponse[];
}

const initialState: MenuState = { items: [] };

const menuSlice = createSlice({
    name: "menu",
    initialState,
    reducers: {
        setMenus(state, action: PayloadAction<MenuResponse[]>) {
            state.items = action.payload;
        },
    },
});

export const { setMenus } = menuSlice.actions;
export default menuSlice.reducer;
